import { html, nothing } from 'lit';
export const NoFeedback = ({ isMobile, feedbackReceived }) => {
    const link = html `
    <a
      href="https://hjelpesenter.finn.no/hc/no/articles/202850691-Hvordan-gi-en-vurdering-av-selgere-og-kj%C3%B8pere-p%C3%A5-Torget#article-comments"
      >Slik fungerer det</a
    >
  `;
    return html `
    <div class="flex flex-col justify-center items-center my-[56px]">
      <div>
        <trust-icon
          classNames="w-[130px] h-[130px] md:w-[230px] md:h-[230px]"
          name="NoFeedback"
        ></trust-icon>
      </div>
      <p class="strong mt-16">
        Du har ikke ${!feedbackReceived ? 'fått' : 'gitt'} noen vurderinger
        enda.
      </p>
      <p>
        Gjør en handel på Torget eller Feriehus og hytter til leie for å kunne gi og få
        vurderinger. Slik fungerer det ${isMobile ? link : nothing}
      </p>
      ${!isMobile ? link : nothing}
    </div>
  `;
};
//# sourceMappingURL=NoFeedbacks.js.map